import { user as permissions } from 'src/store/users/selectors';
import { IRootState } from 'src/store/rootReducer';
import { connect } from 'react-redux';
import React from 'react';
import { hasPermissions, hasSinglePermission, shouldOverridePermissions } from 'src/services/permissions/utils';
import { getPermissions, getRoles } from 'src/store/account/selectors';

interface IProps extends StateProps {
  userPermissions: string[];
  userRoles: string[];
  permissions: string[];
  renderNotPermitted?: () => any;
  children?: any;
  // [key: string]: any;
}
const Has = (props: IProps) => {
  const { permissions: requiredPermissions, userPermissions, userRoles, children, renderNotPermitted } = props;
  const check = Array.isArray(requiredPermissions) ? hasPermissions : hasSinglePermission;
  if (shouldOverridePermissions(userRoles) || check(userPermissions, requiredPermissions)) {
    return children;
  } else {
    return (renderNotPermitted && renderNotPermitted()) || <></>;
  }
};

// export default QuestionsList;
const mapStateToProps = (state: IRootState) => ({
  userPermissions: getPermissions(state),
  userRoles: getRoles(state),
});
type StateProps = ReturnType<typeof mapStateToProps>;

const UserHas = connect(
  mapStateToProps,
  null
)(Has);
export default UserHas;
